import { FunctionComponent } from "react";
import H2 from "../shared/html-tags/h2";
import H1 from "../shared/html-tags/h1";
import DIV from "../shared/html-tags/div";

export type Props = {};

const PricesTopBanner: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  return (
    <div
      className="page-content bg-top2  top-banner"
      style={{ height: "24.75rem" }}
    >
      <div className="inner-content">
        <div
          className="top-left"
          style={{
            display: "flex",
            justifyContent: "stretch",
            alignItems: "center",
            marginLeft: "-8rem",
            paddingLeft: "8rem",
            backgroundImage: "url(/img/prices/22-bang-300x300.png)",
            backgroundPosition: "0 17rem",
            backgroundRepeat: "no-repeat",
            backgroundSize: "12.5rem",
            height: "25rem",
          }}
        >
          <div>
            <H2 language="de">SPSS + Predictive Solutions = PS IMAGO PRO </H2>
            <H1 language="de">Preise und Lizenzinfos</H1>
            <H2
              language="de"
              style={{ fontSize: "0.9rem", fontWeight: "bold" }}
            >
              Du willst IBM SPSS Statistics kaufen? Dann entscheide dich gleich
              für PS IMAGO PRO!
            </H2>
            <H2 language="de">
              PS IMAGO PRO beinhaltet immer eine Lizenz von IBM SPSS Statistics
              <br /> und erweitert diese um wertvolle Funktionen.
            </H2>
          </div>
        </div>
        <DIV language="de" className="top-right">
          <img
            src="/img/prices/prices-584x500.png"
            alt="Roboter kauft PS IMAGO PRO und SPSS Lizenzen ein"
            style={{ border: "none", marginTop: "0" }}
          />
        </DIV>
      </div>
    </div>
  );
};

export default PricesTopBanner;
